﻿/* globals GoogleTagManagerEcommerceDTO, dataLayer */
import Products from './gtm-ecommerce/Products';
import Promotions from './gtm-ecommerce/Promotions';
import AddToCart from './gtm-ecommerce/AddToCart';
import CheckOut from './gtm-ecommerce/CheckOut';
import Purchase from './gtm-ecommerce/Purchase';
import jquery from 'jquery';
import HabEvents from '../../Global/habitaclia-events';
import AuditRepository from '../../Desktop/repositories/audit-repository';

class GtmEcommerce {

    constructor(googleTagManagerEcommerceDTO) {
            this._googleTagManagerEcommerceDTO = googleTagManagerEcommerceDTO;
            this._products = new Products(dataLayer);
            this._promotions = new Promotions(dataLayer);
            this._addToCart = new AddToCart(dataLayer);
            this._checkOut = new CheckOut(dataLayer);
            this._purchase = new Purchase(dataLayer);
            this._auditRepository = new AuditRepository();
            this._sendListProductsView();
            this._sendListProductsViewObraNueva();
            this._registerEvents();
            this._registerEventsDOM(); 
    }

    _registerEvents() {

        jquery.subscribe(HabEvents.EventsEnum.ModuloLiderCargado, () => {
            const dataProductsViewModuloLider = this._getDataProductsListModuloLiderFromDOM();
            const dataPromotionModuloLider = this._getDataPromotionModuloLiderFromDOM();
            this._sendListProductsViewLider(dataProductsViewModuloLider);
            this._sendPromotionViewLider(dataPromotionModuloLider);
            this._registerEventsDOMModuloLider();
        });

        jquery.subscribe(HabEvents.EventsEnum.LogosCargados, () => {
            const dataPromotionLogos = this._getDataLogos();
            this._sendPromotionViewLogos(dataPromotionLogos);
            this._registerEventsDOMLogos();
        });

        jquery.subscribe(HabEvents.EventsEnum.FavoritoAnadido, (e, codigoAnuncio) => {
            const data = this._getGtmData(codigoAnuncio);
            this._addToCart.addWithData(data);
        });

        jquery.subscribe(HabEvents.EventsEnum.FocusToSolicitud, (e, selectorGtm) => {
            //TODO Falta refactorizar, desde la lista no se usa y este script de momento solo se llama desde la lista, cuando se unifiquen lista y ficha se deberá hacer
            this._checkOut.setFocus(jquery(selectorGtm));
        });

        jquery.subscribe(HabEvents.EventsEnum.ConfirmacionSolicitudEnviada, () => {
            //TODO Falta refactorizar, desde la lista no se usa y este script de momento solo se llama desde la lista, cuando se unifiquen lista y ficha se deberá hacer
            this._purchase.setView(jquery(".gtmproductpurchase"));
        });

        jquery.subscribe(HabEvents.GTMEcommerceEventsEnum.ClicGtmItemUrl, (e, oDataClick) => {
            const target = oDataClick.target;
            const url = oDataClick.url + (oDataClick.url.indexOf("?") >= 0 ? "&gtmcoupon=" : "?gtmcoupon=") + oDataClick.gtmlist;
            window.open(url, target);
        });
    }


    _registerEventsDOM() {
        jquery('.gtmproductclick').click((event) => {
           
            let $target = jquery(event.target);

            if (!$target.hasClass('slick-arrow') && !$target.hasClass('js-no-click-item') && !$target.hasClass('js-slick-contact')) {
                event.preventDefault();
                event.stopPropagation();
               
                const id = event.currentTarget.getAttribute('data-id');
                const url = event.currentTarget.getAttribute('data-href');
                const gtmData = this._getGtmData(id);

                this._products.click(gtmData, () => {
                    console.log("GTM product click");
                    document.location.href = url;
                });
                document.location.href = url;
            }
        });
    }

    _registerEventsDOMModuloLider() {

        jquery('#listaliders li').click((event) => {
            event.preventDefault();
            event.stopPropagation();

            const dataProductModuloLider = this._getProductFromDOM(event.currentTarget);
            const url = event.currentTarget.getAttribute('data-url');
            const dataAuditoria = this._getDataAuditoria();
            
            this._products.click(dataProductModuloLider, () => {

                this._auditRepository.auditarClic(dataAuditoria)
                    .then(() => {
                        document.location.href = url + (url.indexOf("?") >= 0 ? "&gtmcoupon=busqueda-modulolider" : "?gtmcoupon=busqueda-modulolider");
                    });
                
            });
        });

        jquery('.jqModLider').click((event) => {
            event.preventDefault();
            const url = event.currentTarget.getAttribute('data-url');
            const dataPromotion = this._getDataPromotionFromDOM(event.currentTarget);
            const dataAuditoria = this._getDataAuditoria();
            this._promotions.click(dataPromotion, () => {
                this._auditRepository.auditarClic(dataAuditoria)
                    .then(() => {
                        document.location.href = url;
                    });
            });

        });
    }

    _registerEventsDOMLogos() {

        jquery('.gtmclickpromo').click((event) => {
            event.preventDefault();
            const url = event.currentTarget.getAttribute('href');
            const dataPromotion = this._getDataPromotionFromDOM(event.currentTarget);
            this._promotions.click(dataPromotion, () => {
                document.location.href = url + (url.indexOf("?") >= 0 ? "&gtmcoupon=promocion" : "?gtmcoupon=promocion");
            });
        });
    }

    _sendListProductsView() {
        const list = this._googleTagManagerEcommerceDTO.listProductsViewBusquedaStandard.concat(...this._googleTagManagerEcommerceDTO.listProductsViewBusquedaAdyancencias);
        this._products.sendListProductView(list);
    }


    _sendPromotionViewLider(promotion) {
        this._promotions.sendPromotionsView(promotion);
    }

    _sendListProductsViewLider(list) {
        this._products.sendListProductView(list);
    }

    _sendListProductsViewObraNueva() {
        this._products.sendListProductView(this._googleTagManagerEcommerceDTO.listProductsViewBusquedaObraNueva);
    }

    _sendPromotionViewLogos(logos) {
        this._promotions.sendPromotionsView(logos);
    }


    _getGtmData(id) {

        let data;

        if (this._googleTagManagerEcommerceDTO.listProductsViewBusquedaStandard && this._googleTagManagerEcommerceDTO.listProductsViewBusquedaStandard.length > 0) {
            data = this._googleTagManagerEcommerceDTO.listProductsViewBusquedaStandard.find((item) => item.id.indexOf(id) >= 0);
        }

        if (!data && this._googleTagManagerEcommerceDTO.listProductsViewBusquedaAdyancencias && this._googleTagManagerEcommerceDTO.listProductsViewBusquedaAdyancencias.length > 0) {
            data = this._googleTagManagerEcommerceDTO.listProductsViewBusquedaAdyancencias.find((item) => item.id.indexOf(id) >= 0);
        }

        return data;
    }

    _getDataProductsListModuloLiderFromDOM() {
        const dataModuloLider = [];
        const domElements = document.querySelectorAll('.gtmlistproductviewdestacado');

        for (let i = 0; i < domElements.length; i++) {
            const item = domElements[i];
            dataModuloLider.push({
                name: item.getAttribute('data-gtmname'),
                id: item.getAttribute('data-gtmid'),
                brand: item.getAttribute('data-gtmbrand'),
                price: item.getAttribute('data-gtmprice'),
                category: item.getAttribute('data-gtmcategory'),
                variant: item.getAttribute('data-gtmvariant'),
                list: item.getAttribute('data-gtmlist'),
                position: item.getAttribute('data-gtmposition')
            });
        }

        return dataModuloLider;
    }

    _getProductFromDOM(domElement) {
        if (domElement) {
            return {
                name: domElement.getAttribute('data-gtmname'),
                id: domElement.getAttribute('data-gtmid'),
                brand: domElement.getAttribute('data-gtmbrand'),
                price: domElement.getAttribute('data-gtmprice'),
                category: domElement.getAttribute('data-gtmcategory'),
                variant: domElement.getAttribute('data-gtmvariant'),
                list: domElement.getAttribute('data-gtmlist'),
                position: domElement.getAttribute('data-gtmposition')
            };

        }
    }

    _getDataPromotionModuloLiderFromDOM() {
        const domElement = document.querySelector('.jqModLider');
        return this._getDataPromotionFromDOM(domElement);
    }

    _getDataPromotionFromDOM(domElement) {

        if (domElement) {
            return {
                id: domElement.getAttribute('data-gtmid'),
                name: domElement.getAttribute('data-gtmname'),
                creative: domElement.getAttribute('data-gtmcreative'),
                position: domElement.getAttribute('data-gtmposition')
            };
        }

        return {};
    }

    _getDataLogos() {
        const dataLogos = [];
        const domElements = document.querySelectorAll('.gtmpromotionview');

        for (let i = 0; i < domElements.length; i++) {
            const item = domElements[i];
            dataLogos.push({
                id: item.getAttribute('data-gtmid'),
                name: item.getAttribute('data-gtmname'),
                creative: item.getAttribute('data-gtmcreative'),
                position: item.getAttribute('data-gtmposition')
            });
        }

        return dataLogos;
    }

    _getDataAuditoria() {
        const domElement = document.querySelector('.jqModLider');

        return {
            codigoEmpresa: domElement.getAttribute('ce'),
            codigoOficina: domElement.getAttribute('co'),
            ids: domElement.getAttribute('ids'),
            codigoCamp: domElement.getAttribute('cc'),
            codigoBanner: domElement.getAttribute('cb'),
            tipoAuditoria: this._googleTagManagerEcommerceDTO.tipoAuditoria
        };
    }


}


new GtmEcommerce(GoogleTagManagerEcommerceDTO);
